import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ProofOfDeliveryCodeService {
  private readonly STORAGE_KEY = 'pod-auth-token';
  private currentCustomerId!: string;

  constructor(private http: HttpClient) {}

  /**
   * Store the active customerId for subsequent verify calls.
   */
  public setCustomerId(id: string): void {
    this.currentCustomerId = id;
  }

  /**
   * Verifies the code for the previously set customerId.
   */
  verifyCode(code: string): Observable<boolean> {
    const cached = sessionStorage.getItem(this.STORAGE_KEY);
    if (cached) {
      return of(true);
    }

    return this.http
      .post<{ token: string }>(
        `${environment.domain}/v1/pod/auth`,
        { customer_id: this.currentCustomerId, code }
      )
      .pipe(
        tap(res => sessionStorage.setItem(this.STORAGE_KEY, res.token)),
        map(() => true),
        catchError(() => of(false))
      );
  }

  get token(): string | null {
    return sessionStorage.getItem(this.STORAGE_KEY);
  }

  clear(): void {
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}